<template>
  <div class="login">
    <h1>{{ text }}</h1>
    <h2>{{ parseTranslation(LOGIN) }}</h2>
    <div class="input-group">
      <label for="username">{{ parseTranslation(USERNAME) }}</label>
      <input type="text" id="username" class="general-input" name="username" required />
    </div>
    <div class="input-group">
      <label for="password">{{ parseTranslation(PASSWORD) }}</label>
      <input
        type="password"
        id="password"
        class="general-input"
        name="password"
        required
      />
    </div>
    <div class="submit-group">
      <button ref="btnSubmit" type="submit" value="Login" @click.prevent="login">
        <span v-if="loader"><Loader color="#fff"/></span>
        <span v-else>{{ parseTranslation(LOGIN) }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/loading/Loader-3'

import { mapActions, mapGetters } from 'vuex'

import * as translationLogin from '@/pages/Login/index.translations'
const { default: translations, ...translationKeys } = translationLogin

export default {
  components: {
    Loader,
  },

  props: {
    close: {
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      loader: false,
      text: '',
    }
  },

  computed: {
    ...mapGetters(['loginModal']),
  },

  methods: {
    ...mapActions([
      'groupName',
      'firstAccess',
      'userLogin',
      'accType',
      'rateCard',
      'toggleLoginModal',
      'executeSurveyAPICall',
      'userLogin',
      'sendMessage',
    ]),

    enter(e) {
      if (this.$refs.btnSubmit && e.keyCode === 13) {
        this.$refs.btnSubmit.click()
      }
    },

    async login() {
      try {
        this.loader = true

        const username = document.getElementById('username').value
        const password = document.getElementById('password').value

        const loginData = await this.executeSurveyAPICall({
          method: 'POST',
          path: 'login',
          payload: { username, password },
        })

        if (!loginData) return

        const user = {
          token: loginData.token,
          username,
          data: loginData.user,
        }

        window.fcWidget.setExternalId(username)
        window.fcWidget.user.setFirstName(username)
        window.fcWidget.user.setEmail(loginData.user.email)

        this.groupName(loginData.user.group_name)
        this.firstAccess(loginData.user.firstAccess)
        this.userLogin(user)
        this.accType(loginData.user.accountType)
        this.rateCard(loginData.user.rate_card)
        this.groupName(loginData.user.group_name)
        this.close()
      } catch (error) {
        this.sendMessage(this.translations[this.language][this.ERROR_CONNECTING])
      } finally {
        this.loader = false
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.enter)
    this.text =
      this.loginModal?.text || this.translations[this.language][this.ACCESS_EXPIRED]
  },
  beforeDestroy() {
    document.addEventListener('keydown', this.enter)
  },
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  height: 83vh;
  h1 {
    text-transform: uppercase;
    @include tipography(24);
    line-height: 28px;
    text-align: center;
    margin-bottom: 30px;
  }
  h2 {
    text-transform: uppercase;
    @include tipography(20);
    margin-bottom: 20px;
  }
  label {
    @include tipography(12);
    display: block;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 5px;
  }
  input {
    background-color: rgba($color: #fff, $alpha: 0.2);
    border: 1px solid transparent;
    border-radius: 15px;
    outline: none;
    padding: 8px 5px 6px;
    font-weight: bold;
    @include tipography(16);
    &:focus {
      border: 1px solid rgba($color: #fff, $alpha: 0.25);
    }
  }
  a {
    @include tipography(12);
    text-align: center;
    display: block;
    &:hover {
      color: $secondary-two;
      text-decoration: underline;
    }
  }
  .light & {
    h1,
    h2,
    label,
    input {
      color: $gray-6;
    }
    input {
      background-color: rgba($color: #000, $alpha: 0.2);
      color: $gray-8;
    }
  }
}

.general-input {
  min-width: calc(100vw / 5);
  border-radius: 2px;
  border: 1px solid #e6e6e6;
  font-size: 16px;
  padding: 5px;
}

.input-group {
  margin-top: 20px;
  &:first-child {
    margin-top: 0px;
  }
}

.submit-group {
  padding: 40px 0 0 0;
  & button {
    @include btn-style;
    padding: 6px 35px;
    margin: 0 !important;
  }
}
</style>
